import includes from 'lodash/includes';
import ReducerBuilder from 'classes/ReducerBuilder';
import * as ResourceApi from 'api/resources';
import {Types as ResourceActionTypes} from 'resources/actions';
import {Types} from './actions';
import initialState from './initialState';
import {isNoU} from "../../utils/DBUtils";

const mapCampaignIdsToPlatforms = campaigns => Object.keys(campaigns).reduce((ids, platform) => {
  const campaign = campaigns[platform];
  ids[platform] = campaign.id;
  return ids;
}, {});

export default ReducerBuilder.make(initialState)
  .forType(Types.SET_FILTERS)
  .reduce((state, {additionalFilters}) => {
    console.log("SET_FILTERS");
    state.additionalFilters = additionalFilters;
  })
  .forType(Types.GET_CAMPAIGNS) // INIT_PAGE
  .reduce((state, {masterCampaignId, ugcResourceType, additionalFilters}) => {
    console.log("GET_CAMPAIGNS reducer")
    state.currentMasterCampaign = masterCampaignId;
    state.ugcResourceType = ugcResourceType
    state.additionalFilters = additionalFilters;
  })
  .forType(Types.SET_CAMPAIGNS)
  .reduce((state, {campaignId, campaigns}) => {
    console.log("SET_CAMPAIGNS reducer")
    // state.currentMasterCampaign = masterCampaignId;
    state.campaigns[campaignId] = mapCampaignIdsToPlatforms(campaigns);
    console.log("SET_CAMPAIGNS reducer done")

  })
  .forType(Types.GET_SUBMISSIONS)
  .reduce((state, {masterCampaignId, platforms, additionalFilters}) => {
    // state.currentMasterCampaign = masterCampaignId;
    state.currentPlatforms = platforms || [];

    if (!isNoU(additionalFilters)) {
      console.log('setting filters', additionalFilters);
      state.additionalFilters = additionalFilters;
    }
  })
  .forType(ResourceActionTypes.GET_RESOURCE_PAGE)
  .reduce((state, {resourceType}) => {
    if (resourceType === ResourceApi.Types.Campaign || resourceType === ResourceApi.Types.UGCSubmission || resourceType === ResourceApi.Types.UGCReceiptSubmission) {
      state.fetching = true;
    }
  })
  .forType(ResourceActionTypes.RECEIVED_RESOURCE_PAGE)
  .reduce((state, {resourceType, resourcePage}) => {
    if ((resourceType === ResourceApi.Types.UGCSubmission) || (resourceType === ResourceApi.Types.UGCReceiptSubmission)) {
      state.fetching = false;

      // Close accordion so results are more prevalent
        state.filterAccordionOpen = false;

        // clear search results since we just did a regular query
        state.searchResults = null;
    }

    if (resourceType === ResourceApi.Types.Campaign) {
      state.fetching = false;

      // store campaign ids for each actual (i.e. non-virtual) campaign resource across platforms,
      // to handle the case of clicking into a campaign and then potentially filtering its
      // submissions by platform.

      state.campaigns = resourcePage.object.reduce((campaignsByMasterId, masterCampaign) => {
        const platforms = Object.keys(masterCampaign.campaigns);

        if (platforms.length > 1 && !includes(platforms, 'null')) {
          console.log(`multiple platforms found on ${masterCampaign.id}`);
        }

        campaignsByMasterId[masterCampaign.id] = mapCampaignIdsToPlatforms(masterCampaign.campaigns);
        return campaignsByMasterId;
      }, {});
    }
  })
  .forType(`${ResourceActionTypes.RECEIVED_ALL_RESOURCES}_BREAK`)
  .reduce((state, {resources}) => {

    // for each break requested: store its campaign ids if we don't already have them, to handle the
    // case of clicking View Submissions at the step level.

    const masterBreak = resources.find(brk => brk.platform === 'MASTER');

    (masterBreak.steps || []).forEach(masterStep => {
      const masterCampaignId = masterStep.ugcCampaignId;

      if (!(masterCampaignId in state.campaigns)) {

        const campaignIds = resources
          .filter(brk => brk.platform !== 'MASTER')
          .reduce((ids, brk) => {
            const platformStep = brk.steps.find(step => step.id === masterStep.id);

            if (platformStep) {
              ids[brk.platform] = platformStep.ugcCampaignId;
            }

            return ids;
          }, {});

        state.campaigns[masterCampaignId] = campaignIds;

      }
    });
  })
  .forType(ResourceActionTypes.GET_RESOURCE)
  .reduce((state, {resourceType}) => {
    if (resourceType === ResourceApi.Types.Campaign) {
      state.fetching = true;
    }
  })
  .forType(ResourceActionTypes.RECEIVED_RESOURCE)
  .reduce((state, {resourceType, resource}) => {
    console.log("RECEIVED_RESOURCE: " + resourceType)
    if (resourceType === ResourceApi.Types.Campaign) {
      state.fetching = false;

      // handle the case of reloading a page of submissions: at that point we have neither a break
      // nor a list of campaigns in the store, so we must fetch the campaign ids for the master
      // campaign id that is present in the current browser route.

      state.campaigns[resource.id] = mapCampaignIdsToPlatforms(resource.campaigns);
    }
  })
    .forType(Types.AUDIT_RECEIPT)
    .reduce((state, {submissionId}) => {
      state.auditing = submissionId;
    })
    .forType(Types.APPROVE_RECEIPT)
    .reduce((state, {id}) => {
      state.sendingAuditForReceipt = id;
    })
    .forType(Types.REJECT_RECEIPT)
    .reduce((state, {id}) => {
        state.sendingAuditForReceipt = id;
    })
    .forType(Types.AUDIT_SUCCESSFUL)
    .reduce((state, {id, auditAction}) => {
        state.audits[id] = {action: auditAction};
        state.sendingAuditForReceipt = null;
    })
    .forType(Types.RESEND_EMAIL)
    .reduce((state, {id}) => {
        state.sendingEmail[id] = true;
    })
    .forType(Types.EMAIL_SENT)
    .reduce((state, {id}) => {
        state.sendingEmail[id] = false;
    })
    .forType(Types.TOGGLE_SILENT_REJECTION)
    .reduce((state, {id}) => {
        if (typeof state.silentRejections[id] === 'undefined') {
            state.silentRejections[id] = true;
        } else {
            state.silentRejections[id] = !state.silentRejections[id]
        }
    })
    .forType(Types.FAILED_TO_AUDIT_SUBMISSION)
    .reduce((state, {id, reason}) => {
        state.errors[id] = {reason: reason}
    })
    .forType(Types.UPDATE_SEARCH_QUERY)
    .reduce((state, {query}) => {
        state.searchQuery = query;
    })
    .forType(Types.SEND_SEARCH_QUERY)
    .reduce((state) => {
        state.fetching = true;
    })
    .forType(Types.RECEIVED_SEARCH_QUERY)
    .reduce((state, {results}) => {
        state.searchResults = results;
        state.fetching = false;

        // Close accordion so results are more prevalent
        state.filterAccordionOpen = false;
    })
    .forType(Types.TOGGLE_FILTER_ACCORDION)
    .reduce((state) => {
        state.filterAccordionOpen = !state.filterAccordionOpen;
    })
  .build();



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/reducer.js